/* import __COLOCATED_TEMPLATE__ from './eisa-scoring-race-detail.hbs'; */
import Component from '@glimmer/component';

const pointsEISA = [50, 47, 44, 41, 39, 37, 35, 33, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];

export default class EisaScoringRaceDetailComponent extends Component
{
	get isAlpine()
	{
		const nordicCount = (this.args.config?.nordic?.races || []).length;
		return this.args.raceIndex >= nordicCount;
	}

	get teams()
	{
		if (this.isAlpine)
		{
			return this.args.config?.alpine?.teams || [];
		}
		return this.args.config?.nordic?.teams || [];
	}

	get scoringTeams()
	{
		if (this.isAlpine)
		{
			return this.args.config?.alpine?.scoringTeams || [];
		}
		return this.args.config?.nordic?.scoringTeams || [];
	}

	get race()
	{
		if (this.isAlpine)
		{
			const nordicCount = (this.args.config?.nordic?.races || []).length;
			const alpineRaces = this.args.config?.alpine?.races || [];
			return alpineRaces[this.args.raceIndex - nordicCount];
		}
		const races = this.args.config?.nordic?.races || [];
		return races[this.args.raceIndex];
	}

	get scoredResults()
	{
		if (!this.race) return [];

		const allResults = this.args.results?.[this.race.resultsFile] || [];

		let eisaResults;
		if (this.isAlpine)
		{
			// Alpine: use all results from file, filter to EISA teams
			eisaResults = allResults.filter(r =>
				this.teams.includes(r.club)
			).sort((a, b) => a.place - b.place);
		}
		else
		{
			// Nordic: filter by class group first
			const classResults = allResults.filter(r => r.ClassGroupId == this.race.classGroupId);
			eisaResults = classResults.filter(r =>
				this.teams.includes(r.club) && r.status === 'OK' && r.totalTimeInMilliseconds
			).sort((a, b) => a.place - b.place);
		}

		// Assign EISA place
		eisaResults.forEach((r, i) => r.eisaPlace = i + 1);

		// Track how many scorers each team has (max 3 can score points)
		const teamScorerCount = {};

		// Non-scoring team athletes and 4th+ athletes from a team don't consume points
		let pointIndex = 0;
		let i = 0;
		while (i < eisaResults.length)
		{
			// Find all athletes with the same ORIGINAL place (they were tied)
			let j = i;
			while (j < eisaResults.length && eisaResults[j].place === eisaResults[i].place)
			{
				j++;
			}
			// i to j-1 are tied (same original place)
			// Find athletes eligible for points (scoring team + not already 3 scorers from that team)
			const tiedScoringAthletes = [];
			for (let k = i; k < j; k++)
			{
				const club = eisaResults[k].club;
				if (this.scoringTeams.includes(club) && (teamScorerCount[club] || 0) < 3)
				{
					tiedScoringAthletes.push(eisaResults[k]);
				}
				else
				{
					eisaResults[k].eisaPoints = 0;
				}
			}

			// Assign averaged points to the tied scoring athletes
			if (tiedScoringAthletes.length > 0)
			{
				let totalPoints = 0;
				for (let k = 0; k < tiedScoringAthletes.length; k++)
				{
					totalPoints += pointsEISA[pointIndex + k] || 0;
				}
				const avgPoints = totalPoints / tiedScoringAthletes.length;
				for (const athlete of tiedScoringAthletes)
				{
					athlete.eisaPoints = avgPoints;
					teamScorerCount[athlete.club] = (teamScorerCount[athlete.club] || 0) + 1;
				}
				pointIndex += tiedScoringAthletes.length;
			}

			i = j;
		}

		return eisaResults;
	}
}
